export const Component = {
    MFAModalOtpLabel: 'This operation involves sensitive information. Please enter your FinPass verification code:',
    RangePickerDays30: 'Last 30 Days',
    RangePickerDays60: 'Last 60 Days',
    RangePickerDays90: 'Last 90 Days',
    RangePickerAll: 'All',
};
